<div style="margin-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;" *ngFor="let landkreis of data$ | async; let i = index">
  <h2>
    {{ landkreis.attributes.BEZ }} {{ landkreis.attributes.GEN }} in {{ landkreis.attributes.BL }}
    <button color="warn" [ngStyle]="{'color': iconColor}" mat-icon-button (click)="manageFavourite()">
      <mat-icon>favorite</mat-icon>
    </button>
  </h2>
  <div class="space-ml" style="display: flex; flex-direction: column; justify-content:space-around">
    <div class="space-y">
      Bestätigte Fälle insgesamt: {{landkreis.attributes.cases}}
    </div>
    <div class="space-y">
      Todesfälle: {{ landkreis.attributes.deaths }}
    </div>
    <div class="space-y">
      Inzidenz: {{ landkreis.attributes.cases7_per_100k | number:'1.0-0' }}
    </div>
    <div class="space-y">
      Inzidenz in {{ landkreis.attributes.BL }}:
      {{ landkreis.attributes.cases7_bl_per_100k | number:'1.0-0' }}
    </div>
  </div>
</div>
